import type { GetByCityChunkPageQuery } from './graphql/chunk-page-by-city.query.gql-types';
import { PageNamesTypes } from './types';
import type { PageName } from './types';

export const sanitizeNames = (
  names: NonNullable<
    NonNullable<GetByCityChunkPageQuery['peopleByCityChunkPage']>['names']
  >
): Array<PageName> => {
  return (
    names
      ?.map((name): PageName | null => {
        switch (name?.__typename) {
          case 'PeopleChildItem': {
            return {
              __typename: PageNamesTypes.child,
              name: name?.name || '',
              toName: name?.toName || '',
              url: name?.url || '',
            };
          }
          case 'PeopleUserBagItem': {
            return {
              __typename: PageNamesTypes.userBag,
              name: name?.name || '',
              count: name?.count || 0,
              url: name?.url || '',
            };
          }
          case 'PeopleProfileItem': {
            return {
              __typename: PageNamesTypes.profile,
              name: name?.name || '',
              photoUrl: name?.photoUrl || '',
              coach: name?.coach || false,
              url: name?.url || '',
              occupationTitle: name?.occupationTitle || '',
              city: name?.city || '',
            };
          }
          default: {
            return null;
          }
        }
      })
      .reduce<Array<PageName>>((result, name: PageName | null) => {
        if (name) {
          return [...result, name];
        } else {
          return result;
        }
      }, []) || []
  );
};
